import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRatingGood(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 20h3V10H3v10Zm18-9.35c0-.935-.731-1.7-1.625-1.7h-5.127l.772-3.884.024-.272a1.31 1.31 0 0 0-.357-.901L13.826 3 8.479 8.601A1.7 1.7 0 0 0 8 9.8v8.5c0 .935.731 1.7 1.625 1.7h7.313c.674 0 1.25-.425 1.495-1.037l2.453-5.993c.073-.195.114-.399.114-.62v-1.623l-.008-.009.008-.068Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
